import { Box, useTheme } from "@mui/material";

import { DashboardTextField } from "@/dashboard-design-system/TextField/DashboardTextField";

type CodeDigitInputProps = {
  value: string;
  onChange: (value: string) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  inputRef: (el: HTMLInputElement | null) => void;
  autoFocus: boolean;
  index: number;
};

export const CodeDigitInput: React.FC<CodeDigitInputProps> = ({
  value,
  onChange,
  onKeyDown,
  inputRef,
  autoFocus,
  index,
}) => {
  const theme = useTheme();
  const codeInputSx = {
    width: 48,
    height: 56,
    marginRight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 1,
    outline: "none",
    background: theme.palette.surface.neutral.white,
    transition: "border-color 0.2s",
    "&:focus-within": {
      borderColor: theme.palette.border.neutral.quiet,
      background: theme.palette.surface.neutral.white,
    },
    position: "relative",
    padding: 0,
  };
  return (
    <Box sx={codeInputSx}>
      <DashboardTextField
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/, ""))}
        onKeyDown={onKeyDown}
        inputRef={inputRef}
        autoFocus={autoFocus}
        inputProps={{
          maxLength: 1,
          inputMode: "numeric",
          style: {
            textAlign: "center",
            fontSize: 32,
            padding: 0,
            height: 56,
            width: 48,
            background: "transparent",
          },
          "data-test": `code-digit-${index + 1}`,
        }}
        sx={{
          width: 48,
          height: 56,
          background: "transparent",
          borderRadius: 1,
          "& input:focus": {
            outline: "none",
            borderColor: theme.palette.border.neutral.quiet,
            boxShadow: theme.palette.border.brand.moderate,
          },
        }}
      />
    </Box>
  );
};
